import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClaimComponent } from './claim.component';
import { ClaimStepOneComponent } from './components/claim-step-one/claim-step-one.component';
import { ClaimStepTwoComponent } from './components/claim-step-two/claim-step-two.component';
import { ClaimStepThreeComponent } from './components/claim-step-three/claim-step-three.component';
import { ClaimStepFourComponent } from './components/claim-step-four/claim-step-four.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime-ex';


const claimRoutes: Routes = [
  { path: '', component: ClaimComponent },
  { path: 'edit/:id', component: ClaimComponent },
];

@NgModule({
  declarations: [
    ClaimComponent,
    ClaimStepOneComponent,
    ClaimStepTwoComponent,
    ClaimStepThreeComponent,
    ClaimStepFourComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(claimRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule ,
  ],
})
export class ClaimModule {}
